module.exports = __webpack_public_path__ + "img/f4.8a750d5c.png";